// CDaaS versioned deploys serve the app from a subdirectory
// (e.g. https://web.e1.resy.com/6.0.3/), which the build reflects in
// `<base href>`. AngularJS derives its route base from that tag, so React
// Router needs the same prefix or none of its paths match the URL.
const getRouterBasename = () => {
  const baseHref = document.querySelector('base')?.getAttribute('href');
  if (!baseHref) return '/';

  try {
    return new URL(baseHref, window.location.origin).pathname;
  } catch {
    return '/';
  }
};

export default getRouterBasename;
